var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1103 2.66871L11.3771 3.79387L8.02944 1.61235L8.76266 0.487188C8.93793 0.218226 9.29821 0.14224 9.56717 0.317511L11.9406 1.86419C12.2096 2.03946 12.2856 2.39975 12.1103 2.66871Z",
    fill: "#45657B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84766 11.5683L4.76691 13.4706L1.77543 14.8698L1.84766 11.5683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42078 13.4464L1.9486 14.603L2.00829 11.8743L4.42048 13.4462M5.07196 13.469L1.72461 11.2877C1.6976 11.3292 1.68287 11.3769 1.68179 11.4262L1.60578 14.8929C1.60457 14.949 1.63311 14.9965 1.67456 15.0235C1.71601 15.0505 1.77077 15.0578 1.8218 15.0337L4.96258 13.5641C5.00723 13.5432 5.04495 13.5105 5.07196 13.469Z",
    fill: "#45657B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 4.22077L7.75195 2.03925L1.72512 11.2877L5.07277 13.4692L11.0996 4.22077Z",
    fill: "#45657B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6146 10.7456C3.49782 10.6695 3.46483 10.5131 3.54093 10.3963L7.84266 3.7951C7.91876 3.67832 8.07517 3.64534 8.19195 3.72144C8.30873 3.79754 8.34172 3.95394 8.26561 4.07073L3.96369 10.6722C3.88759 10.789 3.73119 10.822 3.6144 10.7459L3.6146 10.7456Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80405 11.5214C4.68727 11.4453 4.65429 11.2889 4.73039 11.1721L9.03211 4.5709C9.10821 4.45412 9.26462 4.42113 9.3814 4.49723C9.49818 4.57333 9.53117 4.72974 9.45507 4.84652L5.15315 11.448C5.07705 11.5648 4.92064 11.5978 4.80386 11.5217L4.80405 11.5214Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0927 14.4627L1.86593 15.037C1.73456 15.0983 1.5842 15.0004 1.58729 14.8554L1.61719 13.5012L3.093 14.4629L3.0927 14.4627Z",
    fill: "#45657B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.c81853757ec6cb9cde3de075e5b5bf91.svg";
export { ForwardRef as ReactComponent };